import getPage from './page';

const getParentFolderId = (rootState, pageId) => getPage(rootState, pageId).parentFolderId || null;

export default getParentFolderId;
